<template>
  <div>
    <div class="col-md-4 login-wrapper" style="position: absolute; top: 25%; left: 33%; padding: 30px; background-color: white; border-radius: 7px">
      <h2 class="text-center">Sign in</h2>
      <div class="form-group" v-if="loginOk">
        <b-alert variant="success" show>Login success. Redirecting...</b-alert>
      </div>

      <div class="form-group">
        <label>Login</label>
        <b-input v-model="login" type="text"></b-input>
      </div>
      <div class="form-group">
        <label>Password</label>
        <b-input v-model="password" type="password"></b-input>
      </div>
      <div class="form-group" v-if="use2FA">
        <label>2FA code</label>
        <b-input v-model="code" type="text"></b-input>
      </div>
      <div class="form-group">
        <button @click="doLogin" class="btn btn-primary btn-block">Login</button>
      </div>
      <div class="form-group" v-if="loginError">
        <b-alert variant="danger" show>{{ loginError }}</b-alert>
      </div>
    </div>
  </div>
</template>
<script>

import api from '../api/Api';

export default {
  components: {},
  data() {
    return {
      loginError: null,
      login: null,
      password: null,
      code: null,
      loginOk: false,
      use2FA: false,
    }
  },
  mounted() {
    const location = window.location.href
    this.use2FA = location.includes('leaddist.com') || location.includes('leaddist.team')  || location.includes('leaddistadm.com') || location.includes('benittomedia.com')  || location.includes('bcoservice.com')  || location.includes('sunnymedia.pro')   || location.includes('mprodist.com')
  },

  methods: {
    doLogin: function () {
      api.post('/user/session', {
        login: this.login,
        password: this.password,
        code: this.code
      }).then(response => {
        if (response.status === 200) {
          this.loginOk = true;
          window.localStorage.setItem('auth_token', response.headers['x-set-token']);
          window.location.href = '/';
        }
      }).catch(e => {
        if (e.response.status === 422) {
          this.loginError = 'Invalid login or password';
        }
      })
    }
  }
}
</script>
<style>
body {
  background: inherit;
}
</style>
